module.exports = __webpack_public_path__ + "static/media/zurich-logo-big-white.f5ee3735.png";